const styles = {
  mainDiv: {
    fontSize: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginTop: "2rem",
  },
  imgContainer: {
    marginTop: "0.5rem",
  },
  h5: {
    fontWeight: "bold",
    fontSize: "20px",
  },
  specifiedMargin: {
    marginBottom: "2px",
    marginTop: "0px",
    textAlign: "center",
  },
  italic: {
    fontStyle: "italic",
  },

  nameSection: {
    marginTop: "20px",
    display: "flex",
    alignItems: "flex-end",
    marginBottom: "1rem",
  },
  name: {
    margin: 0,
    whiteSpace: "nowrap",
    marginLeft: "5rem",
  },
  fullName: {
    display: "inline-block",
    minWidth: "fit-content",
    borderBottom: "1px solid black",
    fontWeight: "bold",
    paddingBottom: "2px",
    marginLeft: "10px",
  },
  textCenter: {
    textAlign: "center",
  },
  title: {
    fontSize: "20px",
    margin: "2px",
  },
  salaryRowSection: {
    padding: "0 5rem",
    // marginTop: "3rem",
  },
  deductionLbl: {
    fontWeight: "bold",
  },
  salaryRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
  },
  amount: {
    textAlign: "right",
    whiteSpace: "nowrap",
    margin: "2px",
  },
  salaryRowLbl: {
    textAlign: "left",
    margin: "2px",
  },
  bodyContent: {
    width: "85%",
    margin: "0 auto",
  },
  amtBoundary: {
    borderTop: "1px solid black",
    paddingLeft: "5rem",
  },

  //   .salary-row p {
  //       margin: 0;
  //   }
};
export default styles;
